// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27UNl","content":"styles_content__1j1ix","row":"styles_row__2RR5L","footer":"styles_footer__3HMP3","phraseLength":"styles_phraseLength__2hQtC"};